export interface RevisionPart {
    shortPartDesc: string;
    price: number;
    discount: string;
    subtotal: number;
    quantity: string;
    isApproved: boolean;
    longPartDesc: string;
}
